
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kbs/TkbBoardPage/TkbBoardPage",
      function () {
        return require("private-next-pages/kbs/TkbBoardPage/TkbBoardPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kbs/TkbBoardPage/TkbBoardPage"])
      });
    }
  